<div class="content-container" [ngSwitch]="contentType">
    <div *ngSwitchCase="'GROUP'" class="show-panel">
        <tam-intralinks-group-container [config]="groupConfig"></tam-intralinks-group-container>
    </div>
    <div *ngSwitchCase="'FOLDER'" class="show-panel">
        <tam-intralinks-folder [files]="files" [loading]="false" [isgroup]="false"></tam-intralinks-folder>
    </div>
    <div class="full-height" *ngSwitchCase="'EMPTY'" class="show-panel">
        <div class="no-data">No Folder Selected</div>
    </div>
    <div class="spinner" *ngSwitchDefault>
        <!-- <div loading-spin [isLoading]="true" [loadingSize]="'normal'" style="position:inherit;"></div> -->
    </div>

</div>